module.exports = "\n<md-button class=\"md-primary md-raised md-button\"\n           ng-click=\"$ctrl.submit()\">\n    Force Submit\n</md-button>";